import { ServiceTypes } from 'constants/ServiceTypes';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { NavLink } from 'react-router-dom';
import { ConfigurationService } from 'services/ConfigurationService';
import { useInjection } from 'services/ioc/ioc.react';
import { BpTaggingStore } from 'stores/Tagging/BpTaggingStore';
import { TaggingStore } from 'stores/Tagging/TaggingStore';
import TMLogo from '../images/baseball-logo@2x.png';
import { GameControl } from './GameControl/GameControl';
import { LeftSide, Middle, NavBarWrapper, RightSide } from './NavBarStyles';
import { RadarIndicator } from './RadarIndicator/RadarIndicator';

const NavBar: React.FC = observer(() => {
  const taggingStore = useInjection<TaggingStore>(ServiceTypes.TaggingStore);
  const bpTaggingStore = useInjection<BpTaggingStore>(ServiceTypes.BpTaggingStore);
  const configurationService = useInjection<ConfigurationService>(ServiceTypes.ConfigurationService);

  return (
    <NavBarWrapper>
      <LeftSide>
        {taggingStore.isTagging || bpTaggingStore.isTagging ? (
          <GameControl />
        ) : (
          <>
            <NavLink to='/' exact isActive={(match, location) => location.pathname === '/' || location.pathname === '/games'}>
              Tagging
            </NavLink>
            <NavLink to='/archives/' exact>
              Archives
            </NavLink>
          </>
        )}
      </LeftSide>
      <Middle>
        <img src={TMLogo} alt='Logo' />
        <span>v. {configurationService?.getConfigs()?.appVersion}</span>
      </Middle>
      <RightSide>
        <RadarIndicator />
      </RightSide>
    </NavBarWrapper>
  );
});

export default NavBar;
